<template>
  <v-container fluid>

    <!-- NAV -->

    <inventory-drawer ref="inventoryDrawer" :inventoryView="drawer_is_RM ? inventoryViewRM : inventoryViewPKG" :debitMap="drawer_is_RM ? debitMapRM : debitMapPKG"></inventory-drawer>

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div class="">
      <div pa-0 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs">

          <c-breadcrumbs :breadcrumbs="[{name: 'Productions', to: '/productions/'}, {name: id, to: `/production/${id}`}, {name: `output ${outputID}`, disabled: true}]"></c-breadcrumbs>

        </div>
      </div>
    </div>

    <!-- MAIN CONTENT -->
    <v-row v-if="pageLoading" class="justify-center align-center" style="height: 200px;">
      LOADING
      <v-icon 
      class="rotate-infinite">
      sync
      </v-icon>
    </v-row>
    <div v-else>

      <v-layout align-center class="">
        <div class="title mr-4">
          Production {{ id }} : 
          <span v-if="outputID">
            Output {{ outputID }}
          </span>
          <span v-else>
            Add output
          </span>
        </div>
        <v-chip v-if="production.stage === 0" small color="purple" text-color="white" class="caption">Qued</v-chip>
        <v-chip v-else-if="production.stage === 1" small color="blue" text-color="white" class="caption">In process</v-chip>
        <v-chip v-else-if="production.stage === 2" small color="green" text-color="white" class="caption">Complete</v-chip>
        <v-spacer></v-spacer>

        <!-- MODES -->
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              v-on="on"
            >
              <template v-if="formData.automatic_mode">
                <v-icon class="mr-2">mdi-robot</v-icon> 
                <div>
                  AUTOMATIC MODE
                </div>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
              <template v-else>
                <v-icon class="mr-2">mdi-face</v-icon> 
                <div>
                  CUSTOM MODE
                </div>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0" max-width="300px">
            <div v-if="formData.automatic_mode" class="pa-4 caption">
              <div class="text-center pa-4">
                <v-icon large class="mr-2">mdi-robot</v-icon>
              </div>
              You are in automatic mode. Your inputs will be automatically selected for you to ensure the best raw materials are used and the correct quantities.
              If you wish to customise your inputs (like raw materials) switch to custom mode.
              <v-row class="justify-end mt-4">
                <v-btn text @click="formData.automatic_mode = false">
                  SWITCH TO CUSTOM MODE
                </v-btn>
              </v-row>
            </div>
            <div v-else class="pa-4">
              <div class="pa-4 caption">
                <div class="text-center pa-4">
                  <v-icon large class="mr-2">mdi-face</v-icon>
                </div>
                You are in custom mode. Your can choose what inputs will result in the specified outputs.
                If you wish to use a recipe to perform the production perfectly and automate choosing inputs switch to automatic mode.
              </div>
              <v-row class="justify-end">
                <v-btn text @click="switchToAutomaticMode">
                  SWITCH TO AUTOMATIC MODE
                </v-btn>
              </v-row>
            </div>
          </v-card>
        </v-menu>
        <!-- MODES -->

        <v-btn
        key="save2"
        :color="saveBorderColor"
        :loading="saving"
        class="white--text"
        :disabled="savingDisabled || !isDirty"
        @click="save">
          <div class="ml-1">
            SAVE
          </div>
        </v-btn>
      </v-layout>


      <v-row>

        <v-col lg="6">
          <v-card>
            <!-- SAV ROW -->
            <div :class="['pa-1 text-center']">
              <!--
              <t-item-diff :item1="lastSave" :item2="merged">
                <v-layout 
                slot="item1Header"
                align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                  lastSave
                </v-layout>
                <v-layout 
                slot="item2Header"
                align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                  merged
                </v-layout>
              </t-item-diff>
              -->
              
          

              <div v-if="isDirty" class="backgroundCard pa-2">
                <div v-if="savingDisabled">
                  <div class="caption pa-2">
                    Fix errors in order to save.
                  </div>
                </div>
                <div v-else class="caption">
                  <!-- if your in this block you can save -->
                  <div v-if="formData.automatic_mode">
                    This production is perfectly set up and ready to save.
                  </div>
                  <div v-else>
                    You have unsaved changes.
                  </div>
                </div>
                
              </div>
            
            </div>
            <!-- SAV ROW -->

            <div class="pl-8 pr-8 pt-2 pb-2">
              <div v-if="!formData.output || production.stage === 0" :class="['text-center mt-4 pa-4 transition2s', formData.output ? 'title' : 'display-1']">
                What are you planning to produce?
              </div>
              <div v-else class="title pa-4 text-center">
                Output
              </div>
            
              <v-row 
              @click="selectOutput"
              :class="['crx-box-input pa-4 align-center flex-nowrap', {'title': formData.output}]">
                <template v-if="!formData.output">
                  <v-icon class="mr-4">mdi-magnify</v-icon>
                  <span class="textSecondary--text">Select</span>
                </template>
                <template v-else>
                  <div class="">
                    {{ formData.output.name }}
                  </div>
                </template>
                <v-spacer></v-spacer>
                <v-icon>mdi-chevron-down</v-icon>
              </v-row>
            </div>

              <!-- BUILD -->
              <c-expansion-panel v-if="formData.automatic_mode && formData.output">
                <template v-slot:header="{ expand }">
                  <v-row class="pa-2 align-center justify-center flex-nowrap font-weight-medium">
                    <div class="text-center">
                      BUILD
                      <div v-if="!formData.build" class="pink--text">
                        You must select a build
                      </div>
                    </div>
                    <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
                  </v-row>
                </template>
                <template v-slot:body>
                  <v-card outlined class="ml-8 mr-8">
                    <template>
                    
                      <div>
                        <div class="">
                          <div>
                            <v-row 
                            @click="selectBuild"
                            class="crx-box-input ma-2 pa-2 align-center">
                              <template v-if="!formData.build">
                                <div v-if="builds.length > 0">
                                  Select build
                                </div>
                                <div v-else>
                                  Select a build
                                </div>
                              </template>
                              <template v-else>
                                <div class="">
                                  {{ formData.build.name }}
                                </div>
                              </template>
                              <v-spacer></v-spacer>
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-btn icon
                              v-if="formData.build"
                              class="ma-0 caption"
                              small
                              @click.stop="formData.build = null">
                                <v-icon small>mdi-close</v-icon>
                              </v-btn>
                              <v-btn 
                              v-if="formData.build"
                              text
                              :to="{ path: '/inventory/inventory-definition/build/' + formData.build.id}"
                              class="ma-0 caption"
                              small>
                                View build
                              </v-btn>
                              <!--
                              <router-link
                              v-if="formData.build"
                              class="caption"
                              style="text-decoration: none;"
                              :to="{ path: '/inventory/inventory-definition/build/' + formData.build.id}" @click.native.stop>
                                View build
                              </router-link>
                              -->
                            </v-row>
                          </div>

                        </div>
                      </div>
                  
                      <template v-if="formData.build">

                        <!-- THIS MIGHT BECOME A STAND ALONE CARD -->
                        <v-card class="ma-2" outlined>
                          <c-expansion-panel>
                            <template v-slot:header="{ expand }">
                              <v-row class="pa-2 align-center border-b--thin flex-nowrap">
                                View Recipe
                                <v-spacer></v-spacer>
                                <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
                              </v-row>
                            </template>
                            <template v-slot:body>
                              <div v-if="formData.build" class="text-center pa-3">
                                <img class="c-align-self-start" src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="52px">
                                <div class="pa-2">
                                  Net Weight: 
                                  <span v-if="formData.build.net_weight === null">
                                    Not set
                                  </span>
                                  <c-ms-ii
                                  v-else
                                  sid="si-mass-g"
                                  class="font-weight-medium"
                                  :key="(formData.output || {}).id"
                                  :realValue.sync="formData.build.net_weight"
                                  alwaysScale
                                  labelMode
                                  ></c-ms-ii>
                                </div>

                              </div>
                              <table class="caption lines-b final-table full-width">
                                <!-- RAW MATERIALS -->
                                <tr>
                                  <td colspan="4" class="font-weight-bold pt-4 overline">
                                    Raw materials
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Item
                                  </th>
                                  <th>
                                    x1
                                  </th>
                                  <th>
                                    x{{ formData.quantity }}
                                  </th>
                                  <th>
                                    Stock
                                  </th>
                                </tr>
                                <tr v-for="item in buildRawMaterials" :key="item.id">
                                  <td>
                                    {{ item.definition.name }}
                                  </td>
                                  <td>
                                    <c-ms-ii
                                    :metric_definition="item.definition" 
                                    :realValue="item.quantity"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                  </td>
                                  <td>
                                    <c-ms-ii
                                    :metric_definition="item.definition" 
                                    :realValue="rawMaterialsTimesN[item.inventory_item_id]"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                    <v-progress-linear
                                    class="ma-0"
                                    :value="percentDict[item.inventory_item_id]"
                                    :key="item.inventory_item_id"
                                    style="max-width: 200px;"
                                    background-color="backgroundCard"
                                    :color="percentDict[item.inventory_item_id] > 100 || !totalInventoryMapBUILD[item.inventory_item_id] ? 'pink' : 'color1'"
                                    height="5"
                                    rounded
                                    striped
                                    ></v-progress-linear>
                                    <div v-if="percentDict[item.inventory_item_id] > 100 || !totalInventoryMapBUILD[item.inventory_item_id]" class="pink--text">
                                      short
                                      <c-ms-ii
                                      :metric_definition="item.definition" 
                                      :realValue="rawMaterialsTimesN[item.inventory_item_id] - (totalInventoryMapBUILD[item.inventory_item_id] || 0)"
                                      :key="'a' + (item.definition || {}).id"
                                      alwaysScale
                                      labelMode
                                      ></c-ms-ii>
                                    </div>
                                  </td>
                                  <td>
                                    <template v-if="!totalInventoryMapBUILD[item.inventory_item_id]">
                                      <v-chip
                                      color="pink"
                                      x-small
                                      text-color="white">
                                        OUT OF STOCK
                                      </v-chip>
                                    </template>
                                    <c-ms-ii
                                    v-else
                                    :metric_definition="item.definition" 
                                    :realValue="totalInventoryMapBUILD[item.inventory_item_id]"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                  </td>
                                </tr>
                                <!-- Packaging -->
                                <tr>
                                  <td colspan="4" class="font-weight-bold overline pt-4">
                                    Packaging
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Item
                                  </th>
                                  <th>
                                    x1
                                  </th>
                                  <th>
                                    x{{ formData.finalYield || formData.quantity }}
                                  </th>
                                  <th>
                                    Stock
                                  </th>
                                </tr>
                                <tr v-for="item in buildPackaging" :key="item.id">
                                  <td>
                                    {{ item.definition.name }}
                                  </td>
                                  <td>
                                    <c-ms-ii
                                    :metric_definition="item.definition" 
                                    :realValue="item.quantity"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                  </td>
                                  <td>
                                    <c-ms-ii
                                    :metric_definition="item.definition" 
                                    :realValue="packagingTimesN[item.inventory_item_id]"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                    <v-progress-linear
                                    class="ma-0"
                                    :value="percentDict[item.inventory_item_id]"
                                    :key="item.inventory_item_id"
                                    style="max-width: 200px;"
                                    background-color="backgroundCard"
                                    :color="percentDict[item.inventory_item_id] > 100 || !totalInventoryMapBUILD[item.inventory_item_id] ? 'pink' : 'color1'"
                                    height="5"
                                    rounded
                                    striped
                                    ></v-progress-linear>
                                    <div v-if="percentDict[item.inventory_item_id] > 100 || !totalInventoryMapBUILD[item.inventory_item_id]" class="pink--text">
                                      short
                                      <c-ms-ii
                                      :metric_definition="item.definition" 
                                      :realValue="packagingTimesN[item.inventory_item_id] - (totalInventoryMapBUILD[item.inventory_item_id] || 0)"
                                      :key="'a' + (item.definition || {}).id"
                                      alwaysScale
                                      labelMode
                                      ></c-ms-ii>
                                    </div>
                                  </td>
                                  <td>
                                    <template v-if="!totalInventoryMapBUILD[item.inventory_item_id]">
                                      <v-chip
                                      color="pink"
                                      x-small
                                      text-color="white">
                                        OUT OF STOCK
                                      </v-chip>
                                    </template>
                                    <c-ms-ii
                                    v-else
                                    :metric_definition="item.definition" 
                                    :realValue="totalInventoryMapBUILD[item.inventory_item_id]"
                                    :key="'a' + (item.definition || {}).id"
                                    alwaysScale
                                    labelMode
                                    ></c-ms-ii>
                                  </td>
                                </tr>
                              </table>
                            </template>
                          </c-expansion-panel>
                        </v-card>
                        <!-- THIS MIGHT BECOME A STAND ALONE CARD -->

                        <v-row
                        v-if="!formData.automatic_mode" 
                        class="justify-center">
                          <v-btn
                          :color="recipePerfectlyFilled ? 'green' : 'pink'"
                          dark
                          @click="calculate"
                          :loading="calculating">
                            <v-icon color="white">mdi-calculator</v-icon>
                            Automatically calculate inputs
                          </v-btn>
                        </v-row>

                      </template>

                      <div class="pt-1"></div>
                    </template>
                  </v-card>
                </template>
              </c-expansion-panel>
              <!-- BUILD -->

              <div style="height: 20px;"></div>

          </v-card>

          <v-card v-if="formData.output" class="mt-2">
            <!-- QUANTITY -->
            <div class="pl-8 pr-8">             

              <div :class="['text-center mt-4 pa-4 transition2s', formData.quantity ? 'title' : 'display-1']">
                <span v-if="formData.quantity === 0 || production.stage === 0">
                  How many?
                </span>
                <span v-else>
                  Quantity
                </span>
              </div>

              <div>

                <c-ms-ii
                :metric_definition="formData.output" 
                :realValue.sync="formData.quantity"
                :key="(formData.output || {}).id"
                class="display-1 borderless crx-box-input pa-2"
                ></c-ms-ii>

                <!-- TEST -->
                <template v-if="formData.automatic_mode">
                  <div
                  v-if="formData.build"
                  class="caption pb-2 pt-4 text-center">
                    <div>
                      <v-progress-linear
                      class="ma-0"
                      :value="percent"
                      height="10"
                      :color="!savingDisabled? 'green' : 'pink'"
                      rounded
                      striped
                      ></v-progress-linear>
                      <!-- :color="percent < 95 ? 'green' : percent <= 100 ? 'amber' : 'red'" -->
                    </div>

                    <div class="caption">
                      <span :class="[{'pink--text': formData.quantity > maxQuantity}]">
                        <c-ms-ii
                        :metric_definition="formData.output" 
                        :realValue="formData.quantity"
                        :key="'a' + formData.output.id"
                        alwaysScale
                        labelMode
                        ></c-ms-ii>
                        / 
                        <c-ms-ii
                        :metric_definition="formData.output" 
                        :realValue="maxQuantity"
                        :key="formData.output.id"
                        alwaysScale
                        labelMode
                        ></c-ms-ii>
                      </span>
                      <div v-if="formData.quantity < 0"
                        class="pink--text">
                        * Negative quantaties are not allowed
                      </div>
                      <div v-else-if="maxQuantity === 0"
                        class="pink--text">
                        * You do not have sufficient inventory to produce this item using this recipe
                      </div>
                      <div v-else-if="formData.quantity > maxQuantity"
                        class="pink--text">
                        * You only have enough inventory to make
          
                        <c-ms-ii
                        :metric_definition="formData.output" 
                        :realValue="maxQuantity"
                        :key="(formData.output || {}).id"
                        alwaysScale
                        labelMode
                        class="text-sans font-weight-medium"
                        ></c-ms-ii>

                        using this recipe
                      </div>
                  
                    </div>

                    <div v-if="percent > 95 && percent <= 100" class="pa-4 caption backgroundCard">
                      <v-row class="align-center justify-center overline mb-2">
                        <v-icon small class="mr-1">mdi-alert</v-icon> ATTENTION
                      </v-row>
                      It might be risky to make more than 95% 
                      (
                        <c-ms-ii
                        :metric_definition="formData.output" 
                        :realValue="Math.floor(maxQuantity * 0.95)"
                        :key="(formData.output || {}).id"
                        alwaysScale
                        labelMode
                        class="text-sans font-weight-medium"
                        ></c-ms-ii>
                      )
                      of the max production quantity. You should do a raw materials check before production as you will be using the last amount of certain raw materials. If stock take is not accurate you will be short on ingredients and the production will not be exactly according to the recipe.
                    </div>
                  </div>

                </template>
                <!-- TEST -->

                <div v-if="formData.quantity <= 0" class="caption text-center pink--text">
                  (Enter a quantity above 0)
                </div>
              </div>
            </div>
            <!-- QUANTITY -->
            
            <div style="height: 30px;"></div>

            <!-- FINAL Q -->
            <div v-if="production.stage > 0" class="pa-8">
              <div :class="['text-center mt-4 pa-4 transition2s', formData.finalYield ? 'title' : 'display-1']">
                What was the final yield?
                <span v-if="production.stage === 0 || !production.stage" class="textDisabled--text">(DISABLED)</span>
              </div>
              <c-ms-ii
              :metric_definition="formData.output" 
              :realValue.sync="formData.finalYield"
              :key="'z' + (formData.output || {}).id"
              :disabled="production.stage === 0 || !production.stage"
              class="display-1 borderless crx-box-input pa-2"
              ></c-ms-ii>
              <div v-if="formData.automatic_mode" class="textSecondary--text mt-2 text-center caption">
                Packaging will be updated to match the final yield instead of the quantity specified.
              </div>
            </div>
            <!-- FINAL Q -->
          </v-card>
        </v-col>

        <v-col lg="6">
          <v-card>
            <v-card outlined class="br-default">

              <v-tabs
              v-model="tab_info_inputs"
              background-color="transparent"
              color="basil"
              class="border-b--thin"
              grow
              >
                <v-tab>
                  Info
                </v-tab>
                <v-tab>
                  <div>
                    Raw materials
                    <div v-if="!recipieMatchRM && formData.automatic_mode" class="pink--text overline">
                      ERRORS
                    </div>
                   
                  </div>
                </v-tab>
                <v-tab>
                  <div>
                    Packaging
                    <div v-if="!recipieMatchPKG && formData.automatic_mode" class="pink--text overline">
                      ERRORS
                    </div>
                  </div>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab_info_inputs">
                <v-tab-item>
                  <div class="d-flex display-1 justify-center pa-4 border-b--thin">
                    Info
                  </div>

                  <v-row>
                    <v-col md="12">
                      <div>
                        <div class="overline pl-1 mt-2">
                          BATCH NUMBER
                        </div>
                        <c-input :value.sync="formData.batchNumber" class="crx-box-input"></c-input>

                        <div class="overline pl-1 mt-4">
                          EXPIRY DATE
                        </div>
                        <c-date 
                        class="crx-box-input"
                        :date.sync="formData.expiryDate">
                        </c-date>
                        <v-row class="align-center">
                          <div class="caption text--text text--darken-1">
                            {{ expiryFromNow }}
                          </div>
                          <v-spacer></v-spacer>
                          <recent-batch-expiries :expiryDate.sync="formData.expiryDate"></recent-batch-expiries>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <div class="d-flex display-1 justify-center pa-4 border-b--thin">
                    Raw Materials
                  </div>
                  <raw-materials 
                  :itemsSource.sync="cRawMaterials"
                  :editable="!formData.automatic_mode"
                  :formData="formData"
                  :quantityN="formData.quantity"
                  :buildMaterialsTimesN="rawMaterialsTimesN"
                  :totalInventoryMap="totalInventoryMapRM"
                  :inventoryView="inventoryViewRM"
                  :maxQuantityDict="maxQuantityDict"
                  :percentDict="percentDictRM"
                  :debitMap="debitMapRM"
                  :debitMapTallied="debitMapRMTallied"
                  :remainMap="remainRM"
                  @onOpenInventoryNav="onOpenInventoryNavRM"
                  @addItem="addRawMaterial"
                  @deleteItems="deleteRawMaterials"
                  ref="rawMaterials"
                  >
                  </raw-materials>
                  
                </v-tab-item>

                <v-tab-item>
                  <!-- PACKAGING -->
                  <div class="d-flex display-1 justify-center pa-4 border-b--thin">
                    Packaging
                  </div>
                  <raw-materials 
                  :itemsSource.sync="cPackaging"
                  :editable="!formData.automatic_mode"
                  :formData="formData"
                  :quantityN="formData.finalYield || formData.quantity"
                  :buildMaterialsTimesN="packagingTimesN"
                  :totalInventoryMap="totalInventoryMapPKG"
                  :inventoryView="inventoryViewPKG"
                  :maxQuantityDict="maxQuantityDict"
                  :percentDict="percentDictPKG"
                  :debitMap="debitMapPKG"
                  :debitMapTallied="debitMapPKGTallied"
                  :remainMap="remainPKG"
                  @onOpenInventoryNav="onOpenInventoryNavPKG"
                  @addItem="addPackaging"
                  @deleteItems="deletePackaging"
                  ref="packaging"
                  >
                  </raw-materials>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-card>
        </v-col>

      </v-row>
      
      
    </div>
    <!-- !MAIN CONTENT -->

    <!-- LOGS -->
    <!--
    <v-card class="ma-4">
      <c-expansion-panel>
        <template v-slot:header="{ expand }">
          <v-row class="pa-2 align-center border-b--thin">
            LOGS
            <v-spacer></v-spacer>
            <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
          </v-row>
        </template>
        <template v-slot:body>

          <v-row>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  debitMapRMTallied
                </div>
                <json-viewer :item="debitMapRMTallied"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  rawMaterialsTimesN
                </div>
                <json-viewer :item="rawMaterialsTimesN"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  debitMapRM
                </div>
                <json-viewer :item="debitMapRM"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  debitMapALL
                </div>
                <json-viewer :item="debitMapALL"></json-viewer>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  buildRawMaterials
                </div>
                <json-viewer :item="buildRawMaterials"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  inventoryMapRM
                </div>
                <json-viewer :item="inventoryMapRM"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  inventoryViewRM
                </div>
                <json-viewer :item="inventoryViewRM"></json-viewer>
              </v-card>
            </v-col>
            <v-col md="4">
              <v-card class="grey--text pa-2 ma-2 caption">
                <div class="d-flex caption pa-1">
                  debitMapRM
                </div>
                <json-viewer :item="debitMapRM"></json-viewer>
              </v-card>
            </v-col>
          </v-row>

          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              FORM DATA
            </div>
            <json-viewer :item="formData"></json-viewer>
          </v-card>

          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              FORM DATA
            </div>
            <json-viewer :item="formData"></json-viewer>
          </v-card>
          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              Inventory Set RM
            </div>
            <json-viewer :item="inventorySetRM"></json-viewer>
          </v-card>
          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              Inventory Map RM
            </div>
            <json-viewer :item="inventoryMapRM"></json-viewer>
          </v-card>

          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              Inventory Set PKG
            </div>
            <json-viewer :item="inventorySetPKG"></json-viewer>
          </v-card>
          <v-card class="grey--text pa-2 ma-2 caption">
            <div class="d-flex caption pa-1">
              Inventory Map PKG
            </div>
            <json-viewer :item="inventoryMapPKG"></json-viewer>
          </v-card>
          <v-card class="grey--text pa-4 caption">
            <div class="d-flex title pa-4">
              Merge map RM
            </div>
            {{ mergeMapRM }}
            <div class="d-flex title pa-4">
              Merge map PKG
            </div>
            {{ mergeMapPKG }}
          </v-card>
        </template>
      </c-expansion-panel>
    </v-card>
    -->
    <!-- LOGS -->

    <!-- DIALOGS -->
    <c-select-inv-def-dialog ref="selectItemDialog" :currentSelectedID="(formData.output || {}).id">
      <template v-slot:extra="slotProps">
        <dialog-extra-max-quantity :item="slotProps.item"></dialog-extra-max-quantity>
      </template>
    </c-select-inv-def-dialog>

    <select-build-dialog
    ref="selectBuildDialog"
    :inventoryItemId="formData.output ? formData.output.id : null" :currentSelectedID="(formData.build || {}).id"></select-build-dialog>

  </v-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SelectBuildDialog from '@/components/dialogs/select-build/Dialog'
import RecipeRow from './components/recipe-table-row'
import InventoryHelper from '@/js/shared/inventory.js'
import RawMaterials from './raw-materials'
import InventoryDrawer from './bottom-drawer'
import JsonViewer from '@/components/toolbox/json-viewer/Main'
import DialogExtraMaxQuantity from './components/dialog-extra-max-quantity'
import RecentBatchExpiries from './components/recent-batch-expiries'

export default {
  props: {
    id: null,
    outputID: null
  },
  components: {
    SelectBuildDialog,
    RecipeRow,
    RawMaterials,
    InventoryDrawer,
    JsonViewer,
    DialogExtraMaxQuantity,
    RecentBatchExpiries
  },
  data () {
    return {
      tab_info_inputs: 0,
      pageLoading: true,
      calculating: false,
      allowAutomaticCalculations: false,
      production: {
        stage: 0
      },
      drawer_is_RM: true,
      formData: {
        automatic_mode: true,
        output: null,
        quantity: 0,
        build: null,
        batchNumber: null,
        expiryDate: null,
        finalYield: 0
      },
      lastSave: {
        automatic_mode: true,
        output: null,
        quantity: 0,
        build: null,
        batchNumber: null,
        expiryDate: null,
        finalYield: 0,
        debitMapRM: {},
        debitMapPKG: {}
      },
      builds: [],
      buildItems: [],
      filters: {
        sortCol: 'maxQuantity',
        sortAscending: true,
        search: {

        }
      },
      inventoryMapBuild: {},
      inventoryMapRM: {},
      inventoryMapPKG: {},
      saving: false,
      savedInputsALL: [],
      savedInputsRM: [],
      savedInputsPKG: [],
      mergeMapALL: {},
      mergeMapRM: {},
      mergeMapPKG: {},
      debitMapALL: {},
      debitMapRM: {},
      debitMapPKG: {},
      cRawMaterials: {},
      cPackaging: {},
      rawMaterialsTimesN: {},
      packagingTimesN: {}
    }
  },
  computed: {
    saveBorderColor () {
      if (this.isDirty) {
        if (this.savingDisabled) {
          return 'pink'
        }
        if (this.formData.automatic_mode) {
          return 'green'
        } else {
          return 'blue'
        }
      }
    },
    expiryFromNow () {
      if (this.$moment.utc(this.formData.expiryDate).isValid()) {
        return this.$moment.utc(this.formData.expiryDate).fromNow()
      }
      return ''
    },
    savingDisabled () {
      if (this.formData.automatic_mode) {
        if (!this.formData.build) {
          return true
        }
        if (this.formData.quantity <= 0) {
          return true
        }
        if (!this.recipePerfectlyFilled) {
          return true
        }
      }
    },
    recipePerfectlyFilled () {
      return this.recipieMatchRM && this.recipieMatchPKG
    },
    recipieMatchRM () {
      return _.isEqual(this.rawMaterialsTimesN, this.debitMapRMTallied)
    },
    debitMapRMTallied () {
      var map = {}
      Object.keys(this.debitMapRM).map((key, index) => {
        map[key] = Object.values(this.debitMapRM[key]).reduce((a, b) => a + b, 0)
      })
      return map
    },
    recipieMatchPKG () {
      return _.isEqual(this.packagingTimesN, this.debitMapPKGTallied)
    },
    debitMapPKGTallied () {
      var map = {}
      Object.keys(this.debitMapPKG).map((key, index) => {
        map[key] = Object.values(this.debitMapPKG[key]).reduce((a, b) => a + b, 0)
      })
      return map
    },
    buildRawMaterials () {
      var items = (this.formData.build || {}).items || []
      return items.filter(item => item.type === 0)
    },
    buildPackaging () {
      var items = (this.formData.build || {}).items || []
      return items.filter(item => item.type === 1)
    },
    remainRM () {
      var debitMap = JSON.parse(JSON.stringify(this.debitMapRM))
      Object.keys(debitMap).forEach(inventory_item_id => {
        Object.keys(debitMap[inventory_item_id]).forEach(inventory_id => {
          var inv_item_quantity = ((this.inventoryViewRM[inventory_item_id] || {})[inventory_id] || {}).quantity
          var dm_quantity = debitMap[inventory_item_id][inventory_id]
          debitMap[inventory_item_id][inventory_id] = inv_item_quantity - dm_quantity
        })
      })
      return debitMap
    },
    remainPKG () {
      var debitMap = JSON.parse(JSON.stringify(this.debitMapPKG))
      Object.keys(debitMap).forEach(inventory_item_id => {
        Object.keys(debitMap[inventory_item_id]).forEach(inventory_id => {
          var inv_item_quantity = ((this.inventoryViewPKG[inventory_item_id] || {})[inventory_id] || {}).quantity
          var dm_quantity = debitMap[inventory_item_id][inventory_id]
          debitMap[inventory_item_id][inventory_id] = inv_item_quantity - dm_quantity
        })
      })
      return debitMap
    },
    inventoryViewRM () {
      var inventoryArray = Object.values(this.inventoryMapRM).flat(1)
      return InventoryHelper.mergeDebitsBackToInventory(inventoryArray, this.savedInputsRM, this.mergeMapRM).reduce((a, i) => {
        if (!a[i.inventory_item_id]) {
          a[i.inventory_item_id] = {}
        }
        a[i.inventory_item_id][i.id] = i
        return a
      }, {})
    },
    inventoryViewPKG () {
      var inventoryArray = Object.values(this.inventoryMapPKG).flat(1)
      return InventoryHelper.mergeDebitsBackToInventory(inventoryArray, this.savedInputsPKG, this.mergeMapPKG).reduce((a, i) => {
        if (!a[i.inventory_item_id]) {
          a[i.inventory_item_id] = {}
        }
        a[i.inventory_item_id][i.id] = i
        return a
      }, {})
    },
    inventoryViewBUILD () {
      var inventoryArray = Object.values(this.inventoryMapBuild).flat(1)
      return InventoryHelper.mergeDebitsBackToInventory(inventoryArray, this.savedInputsALL, this.mergeMapALL).reduce((a, i) => {
        if (a[i.inventory_item_id]) {
          a[i.inventory_item_id].push(i)
        } else {
          a[i.inventory_item_id] = [i]
        }
        return a
      }, {})
    },
    inventorySetBuild () {
      var buildItems = ( this.formData.build || {}).items || []
      return [...new Set(buildItems.map(item => item.inventory_item_id))]
    },
    inventorySetRM () {
      return Object.keys(this.cRawMaterials)
    },
    inventorySetPKG () {
      return Object.keys(this.cPackaging)
    },
    totalRecipeTimes1 () {
      var map = {}
      var items = (this.formData.build || {}).items || []
      items.forEach(item => {
        if (map[item.inventory_item_id]) {
          map[item.inventory_item_id] += item.quantity
        } else {
          map[item.inventory_item_id] = item.quantity
        }
      })
      return map
    },
    totalRecipeTimesN () {
      var map = {}
      var items = (this.formData.build || {}).items || []
      items.forEach(item => {
        if (map[item.inventory_item_id]) {
          map[item.inventory_item_id] += (item.quantity * this.formData.quantity)
        } else {
          map[item.inventory_item_id] = (item.quantity * this.formData.quantity)
        }
      })
      return map
    },
    totalInventoryMapBUILD () {
      var map = {}
      Object.keys(this.inventoryViewBUILD).map((key, index) => {
        map[key] = this.inventoryViewBUILD[key].reduce((a, i) => a + i.quantity, 0)
      })
      return map
    },
    totalInventoryMapRM () {
      var map = {}
      Object.keys(this.inventoryViewRM).map((key, index) => {
        var unexpired = InventoryHelper.getUnexpired(Object.values(this.inventoryViewRM[key]))
        map[key] = {
          total: Object.values(this.inventoryViewRM[key]).reduce((a, i) => a + i.quantity, 0),
          unexpired: unexpired.reduce((a, i) => a + i.quantity, 0)
        }
      })
      return map
    },
    totalInventoryMapPKG () {
      var map = {}
      Object.keys(this.inventoryViewPKG).map((key, index) => {
        var unexpired = InventoryHelper.getUnexpired(Object.values(this.inventoryViewPKG[key]))
        map[key] = {
          total: Object.values(this.inventoryViewPKG[key]).reduce((a, i) => a + i.quantity, 0),
          unexpired: unexpired.reduce((a, i) => a + i.quantity, 0)
        }
      })
      return map
    },
    maxQuantityDict () {
      var map = {}
      Object.keys(this.totalRecipeTimes1).forEach(inventory_item_id => {
        var max = Math.floor(this.totalInventoryMapBUILD[inventory_item_id] / this.totalRecipeTimes1[inventory_item_id])
        map[inventory_item_id] = max || 0
      })
      return map
    },
    maxQuantity () {
      if (Object.keys(this.maxQuantityDict).length < 1) {
        return 0
      }
      return Object.values(this.maxQuantityDict).reduce((a, i) => i < a ? i : a)
    },
    percentDictRM () {
      var map = {}
      Object.keys(this.cRawMaterials).forEach(inventory_item_id => {
        var totalInStock = ( this.totalInventoryMapRM[inventory_item_id] || {}).total || 0
        var totalDebited = this.debitMapRMTallied[inventory_item_id]
        map[inventory_item_id] = 100 - (((totalInStock - totalDebited) / totalInStock) * 100) || 0
      })
      return map
    },
    percentDictPKG () {
      var map = {}
      Object.keys(this.cPackaging).forEach(inventory_item_id => {
        var totalInStock = ( this.totalInventoryMapPKG[inventory_item_id] || {}).total || 0
        var totalDebited = this.debitMapPKGTallied[inventory_item_id]
        map[inventory_item_id] = 100 - (((totalInStock - totalDebited) / totalInStock) * 100) || 0
      })
      return map
    },
    percentDict () {
      var map = {}
      Object.keys(this.totalRecipeTimes1).forEach(inventory_item_id => {
        var percent = 100 - (((this.totalInventoryMapBUILD[inventory_item_id] - this.totalRecipeTimesN[inventory_item_id]) / this.totalInventoryMapBUILD[inventory_item_id]) * 100)
        map[inventory_item_id] = percent
      })
      return map
    },
    percent () {
      return 100 - (((this.maxQuantity - this.formData.quantity) / this.maxQuantity) * 100) || 0
    },
    isDirty () {
      return !_.isEqual(this.lastSave, this.merged)
    },
    merged () {
      var merged = {
        automatic_mode: this.formData.automatic_mode,
        output: (this.formData.output || {}).id || null,
        quantity: this.formData.quantity,
        build: (this.formData.build || {}).id || null,
        batchNumber: this.formData.batchNumber,
        expiryDate: this.formData.expiryDate,
        finalYield: this.formData.finalYield,
        debitMapRM: this.debitMapRM,
        debitMapPKG: this.debitMapPKG
      }
      return merged
    }
  },
  watch: {
    'formData.quantity' (nv) {
      if (this.allowAutomaticCalculations && this.formData.automatic_mode) {
        this.calculate()
      }
    },
    'formData.finalYield' (nv) {
      if (this.allowAutomaticCalculations && this.formData.automatic_mode) {
        this.calculate()
      }
    },
    'formData.build' (nv) {
      if (this.allowAutomaticCalculations && this.formData.automatic_mode) {
        this.calculate().then(() => {
          setTimeout(() => {
            if (this.$refs.rawMaterials) {
              this.$refs.rawMaterials.filters.sortCol = 'percent_used'
              this.$refs.rawMaterials.filters.sortAscending = false
              this.$refs.rawMaterials.resort()
            }
            if (this.$refs.packaging) {
              this.$refs.packaging.filters.sortCol = 'percent_used'
              this.$refs.packaging.filters.sortAscending = false
              this.$refs.packaging.resort()
            }
          }, 150)
        })
      }
    },
    inventorySetBuild (nv) {
      this.fetchInventory(this.inventorySetBuild)
        .then(map => {
          this.inventoryMapBuild = map
        })
    },
    inventorySetRM (nv) {
      Object.keys(this.debitMapRM).forEach(id => {
        if (nv.indexOf(id) === -1) {
          Vue.delete(this.debitMapRM, id)
        }
      })
      this.fetchInventory(this.inventorySetRM)
        .then(map => {
          this.inventoryMapRM = map
        })
    },
    inventorySetPKG (nv) {
      Object.keys(this.debitMapPKG).forEach(id => {
        if (nv.indexOf(id) === -1) {
          Vue.delete(this.debitMapPKG, id)
        }
      })
      this.fetchInventory(this.inventorySetPKG)
        .then(map => {
          this.inventoryMapPKG = map
        })
    }
  },
  methods: {
    addRawMaterial (item) {
      Vue.set(this.cRawMaterials, item.id, {definition: item})
    },
    deleteRawMaterials (ids) {
      for (var i = ids.length - 1; i >= 0; --i) {
        Vue.delete(this.cRawMaterials, ids[i])
      }
      this.$refs.rawMaterials.onSuccessfullDelete()
    },
    addPackaging (item) {
      Vue.set(this.cPackaging, item.id, {definition: item})
    },
    deletePackaging (ids) {
      for (var i = ids.length - 1; i >= 0; --i) {
        Vue.delete(this.cPackaging, ids[i])
      }
      this.$refs.packaging.onSuccessfullDelete()
    },
    setRawMaterialsTimesN () {
      var items = (this.formData.build || {}).items || []
      items = items.filter(item => item.type === 0)
      var map = {}
      items.forEach(item => {
        if (map[item.inventory_item_id]) {
          map[item.inventory_item_id] += (item.quantity * this.formData.quantity)
        } else {
          map[item.inventory_item_id] = (item.quantity * this.formData.quantity)
        }
      })
      this.rawMaterialsTimesN = map
    },
    setPackagingTimesN () {
      var items = (this.formData.build || {}).items || []
      items = items.filter(item => item.type === 1)
      var map = {}
      var quantity = this.formData.finalYield || this.formData.quantity
      items.forEach(item => {
        if (map[item.inventory_item_id]) {
          map[item.inventory_item_id] += (item.quantity * quantity)
        } else {
          map[item.inventory_item_id] = (item.quantity * quantity)
        }
      })
      this.packagingTimesN = map
    },
    switchToAutomaticMode () {
      this.$root.$confirm('Switch to automatic', 'Switching to automatic will recalculate all raw materials and packaging according to the recipe. Proceed?', { color: 'pink' })
      .then(confirm => {
        if (confirm) {
          this.formData.automatic_mode = true
          this.calculate()
        }
      })
    },
    convertDBInputsToDebitMaps (inputs, mergeMap) {
      var rmMap = {}
      inputs.forEach(input => {
        if (!rmMap[input.inventory_item_id]) {
          rmMap[input.inventory_item_id] = {}
        }
        var invMergeId = mergeMap[input.id]
        var currentDebit = rmMap[input.inventory_item_id][invMergeId] || 0
        Vue.set(rmMap[input.inventory_item_id], invMergeId, currentDebit + input.quantity)
      })
      return rmMap
    },
    
    calculate: _.debounce(function (e) {
      console.log('calculating')
      return new Promise((resolve, reject) => {
        if (!this.formData.build) {
          return
        }
    
        this.calculating = true

        this.cRawMaterials = this.formData.build.items.filter(item => item.type === 0).reduce((a, i) => {
          a[i.inventory_item_id] = i
          return a
        }, {})

        this.cPackaging = this.formData.build.items.filter(item => item.type === 1).reduce((a, i) => {
          a[i.inventory_item_id] = i
          return a
        }, {})

        var invSetRM = Object.keys(this.cRawMaterials)
        var invSetPKG = Object.keys(this.cPackaging)

        axios.all([
          this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetRM),
          this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetPKG)
          ])
          .then(axios.spread((inventory_response_rm, inventory_response_pkg) => {
            this.setRawMaterialsTimesN()
            this.setPackagingTimesN()

            var invMapRM = inventory_response_rm.data.map
            var inventoryArrayRM = Object.values(invMapRM).flat(1)
            this.mergeMapRM = InventoryHelper.mergeMapMultiple(inventoryArrayRM, this.savedInputsRM)
            var inventoryViewRM = InventoryHelper.mergeDebitsBackToInventory(inventoryArrayRM, this.savedInputsRM, this.mergeMapRM).reduce((a, i) => {
              if (a[i.inventory_item_id]) {
                a[i.inventory_item_id].push(i)
              } else {
                a[i.inventory_item_id] = [i]
              }
              return a
            }, {})
            this.debitMapRM = InventoryHelper.debitMultiple(inventoryViewRM, this.rawMaterialsTimesN)


            var invMapPKG = inventory_response_pkg.data.map
            var inventoryArrayPKG= Object.values(invMapPKG).flat(1)
            this.mergeMapPKG = InventoryHelper.mergeMapMultiple(inventoryArrayPKG, this.savedInputsPKG)
            var inventoryViewPKG = InventoryHelper.mergeDebitsBackToInventory(inventoryArrayPKG, this.savedInputsPKG, this.mergeMapPKG).reduce((a, i) => {
              if (a[i.inventory_item_id]) {
                a[i.inventory_item_id].push(i)
              } else {
                a[i.inventory_item_id] = [i]
              }
              return a
            }, {})
            this.debitMapPKG = InventoryHelper.debitMultiple(inventoryViewPKG, this.packagingTimesN)
            this.$nextTick(() => {
              if (this.$refs.rawMaterials) {
                this.$refs.rawMaterials.filters.sortCol = 'percent_used'
                this.$refs.rawMaterials.filters.sortAscending = false
                this.$refs.rawMaterials.resort()
              }
              if (this.$refs.packaging) {
                this.$refs.packaging.filters.sortCol = 'percent_used'
                this.$refs.packaging.filters.sortAscending = false
                this.$refs.packaging.resort()
              }
            })
          }))
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.calculating = false
            resolve()
          })
      })
    }, 100, {leading: true}),

    /*
    calculate () {
      if (!this.formData.build) {
        return
      }
      this.calculating = true
      this.cRawMaterials = this.formData.build.items.filter(item => item.type === 0)
      this.cPackaging = this.formData.build.items.filter(item => item.type === 1)
      // here

      var invSetRM = [...new Set(this.cRawMaterials.map(item => item.inventory_item_id))]
      var invSetPKG = [...new Set(this.cPackaging.map(item => item.inventory_item_id))]

      axios.all([
        this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetRM),
        this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetPKG)
        ])
        .then(axios.spread((inventory_response_rm, inventory_response_pkg) => {
          var invMapRM = inventory_response_rm.data.map
          var inventoryArrayRM = Object.values(invMapRM).flat(1)
          this.mergeMapRM = InventoryHelper.mergeMapMultiple(inventoryArrayRM, this.savedInputsRM)
          var inventoryViewRM = InventoryHelper.mergeDebitsBackToInventory(inventoryArrayRM, this.savedInputsRM, this.mergeMapRM).reduce((a, i) => {
            if (a[i.inventory_item_id]) {
              a[i.inventory_item_id].push(i)
            } else {
              a[i.inventory_item_id] = [i]
            }
            return a
          }, {})
          this.debitMapRM = InventoryHelper.debitMultiple(inventoryViewRM, this.rawMaterialsTimesN)


          var invMapPKG = inventory_response_pkg.data.map
          var inventoryArrayPKG= Object.values(invMapPKG).flat(1)
          this.mergeMapPKG = InventoryHelper.mergeMapMultiple(inventoryArrayPKG, this.savedInputsPKG)
          var inventoryViewPKG = InventoryHelper.mergeDebitsBackToInventory(inventoryArrayPKG, this.savedInputsPKG, this.mergeMapPKG).reduce((a, i) => {
            if (a[i.inventory_item_id]) {
              a[i.inventory_item_id].push(i)
            } else {
              a[i.inventory_item_id] = [i]
            }
            return a
          }, {})
          this.debitMapPKG = InventoryHelper.debitMultiple(inventoryViewPKG, this.packagingTimesN)
        }))
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
        })
        .then(() => {
          this.calculating = false
        })


      // here
    }, */
    /* onManualQuantityUpdate (debitMap, item, quantity) {
      if (!debitMap[item.inventory_item_id]) {
        console.log('nested item doesnt exist')
        // debitMap[item.inventory_item_id] = {}
        Vue.set(debitMap, item.inventory_item_id, {})
      }
      Vue.set(debitMap[item.inventory_item_id], item.id, quantity)
      // debitMap[item.inventory_item_id][item.id] = quantity
      // debitMap[item.inventory_item_id][item.id]
      // debitMapRM[nav_item.inventory_item_id] || {})[nav_item.id]
    }, */
    save () {
      if (this.outputID !== 'new') {
        this.editOutput()
        .catch(error => { this.$root.$errorSnackbar(error) })
      } else {
        this.addOutput()
        .catch(error => { 
          console.log(error)
          this.$root.$errorSnackbar(error) 
          })
      }
    },
    addOutput () {
      return new Promise((resolve, reject) => {
        var data = {
          productionId: this.id,
          automatic_mode: this.formData.automatic_mode,
          buildID: (this.formData.build || {}).id,
          batchNumber: this.formData.batchNumber,
          expiryDate: this.formData.expiryDate,
          inventory_item_id: (this.formData.output || {}).id,
          quantity: this.formData.quantity,
          finalYield: this.formData.finalYield || 0,
          inputsRM: this.debitMapRM,
          inputsPKG: this.debitMapPKG
        }
        console.log(data)
        this.$axios.post('productions/add-output',
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            // this.apiChainLoader()
            this.$router.push(`/production/${this.id}`)
            resolve()
          })
          .catch(error => {
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    editOutput () {
      return new Promise((resolve, reject) => {
        var data = {
          id: this.outputID,
          automatic_mode: this.formData.automatic_mode,
          productionId: this.id,
          buildID: (this.formData.build || {}).id,
          batchNumber: this.formData.batchNumber,
          expiryDate: this.formData.expiryDate,
          inventory_item_id: this.formData.output.id,
          quantity: this.formData.quantity,
          finalYield: this.formData.finalYield || 0,
          inputsRM: this.debitMapRM,
          inputsPKG: this.debitMapPKG,
          mergeMapRM: this.mergeMapRM,
          mergeMapPKG: this.mergeMapPKG
        }
        this.$axios.post('productions/edit-output',
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            this.apiChainLoader()
            // this.$router.push(`/production/${this.id}`)
            resolve()
          })
          .catch(error => {
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    clickSortHeader (column) {
      if (this.filters.sortCol !== column) {
        this.filters.sortAscending = false
      } else {
        this.filters.sortAscending = !this.filters.sortAscending
      }
      this.filters.sortCol = column
    },
    onOpenInventoryNavRM (row) {
      this.drawer_is_RM = true
      this.$nextTick(() => {
        this.$refs.inventoryDrawer.open(row)
      })
    },
    onOpenInventoryNavPKG (row) {
      this.drawer_is_RM = false
      this.$nextTick(() => {
        this.$refs.inventoryDrawer.open(row)
      })
    },
    selectBuild () {
      this.$refs.selectBuildDialog.open((this.formData.output || {}).id)
        .then((selectedItem) => {
          this.formData.build = selectedItem
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    selectOutput () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.formData.output = selectedItem
          this.formData.quantity = 0
          // async
          this.debounceFetchBuilds()
            .then(builds => {
              this.builds = builds
              if (this.builds.length > 0) {
                this.formData.build = this.builds[0]
              } else {
                this.formData.build = null
              }
            })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    debounceFetchBuilds: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.get(`/product-builds/inventory-item/${this.formData.output.id}`)
          .then(response => {
            resolve(response.data.rows)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    }, 150, {leading: true}),
    fetchInventory (_set) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.post(`/inventory/inventory-item-id/multiple`, _set)
          .then(response => {
            resolve(response.data.map)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    apiChainLoader () {
      var output
      var build
      var definition
      var inputs
      this.pageLoading = true

      axios.all([
        this.$axios.get('productions/' + this.id),
        this.$axios.get(`productions/${this.id}/outputs`)
        ])
        .then(axios.spread((production_response, output_response) => {
          this.production = production_response.data
          output = output_response.data.rows.find(item => item.id === parseInt(this.outputID))

          this.lastSave.build = output.product_build
          this.lastSave.quantity = output.quantity
          this.lastSave.output = output.inventory_item_id
          this.lastSave.automatic_mode = output.automatic_mode === 1
          this.lastSave.expiryDate = output.expiry_date
          this.lastSave.batchNumber = output.batch_number
          this.lastSave.finalYield = output.yield

          return axios.all([
            this.$axios.get(`product-builds/${output.product_build}`),
            this.$axios.get(`inventory-definitions/${output.inventory_item_id}`),
            this.$axios.get(`productions/output/${output.id}/inputs`)
          ])
        }))
        .then(axios.spread((product_build_response, definition_response, inputs_response) => {
          build = product_build_response.data.build
          definition = definition_response.data
          inputs = inputs_response.data
          this.formData.build = build
          this.formData.output = definition
          this.formData.quantity = output.quantity
          this.formData.automatic_mode = output.automatic_mode === 1
          this.formData.expiryDate = output.expiry_date
          this.formData.batchNumber = output.batch_number
          this.formData.finalYield = output.yield

          this.savedInputsALL = inputs
          this.savedInputsRM = inputs.filter(item => item.type === 0)
          this.savedInputsPKG = inputs.filter(item => item.type === 1)
          
          /* var raw_materials = inputs.filter(item => item.type === 0)
          var map = {}
          raw_materials.forEach(item => {
            if (!map[item.inventory_item_id]) {
              map[item.inventory_item_id] = item
            }
          })

          this.cRawMaterials = JSON.parse(JSON.stringify(Object.values(map))) */

          this.cRawMaterials = inputs.filter(item => item.type === 0).reduce((a, i) => {
            a[i.inventory_item_id] = i
            return a
          }, {})

          this.cPackaging = inputs.filter(item => item.type === 1).reduce((a, i) => {
            a[i.inventory_item_id] = i
            return a
          }, {})

          // this.cPackaging = inputs.filter(item => item.type === 1)
          this.setRawMaterialsTimesN()
          this.setPackagingTimesN()

          var invSetALL = [...new Set(this.savedInputsALL.map(item => item.inventory_item_id))]
          var invSetRM = [...new Set(this.savedInputsRM.map(item => item.inventory_item_id))]
          var invSetPKG = [...new Set(this.savedInputsPKG.map(item => item.inventory_item_id))]
          return axios.all([
            this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetALL),
            this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetRM),
            this.$axios.post(`/inventory/inventory-item-id/multiple`, invSetPKG)
          ])
        }))
        .then(axios.spread((inventory_response_all, inventory_response_rm, inventory_response_pkg) => {
          var invMapALL = inventory_response_all.data.map
          var inventoryArrayALL = Object.values(invMapALL).flat(1)
          this.mergeMapALL = InventoryHelper.mergeMapMultiple(inventoryArrayALL, this.savedInputsALL)
          this.debitMapALL = this.convertDBInputsToDebitMaps(this.savedInputsALL, this.mergeMapALL)

          var invMapRM = inventory_response_rm.data.map
          var inventoryArrayRM = Object.values(invMapRM).flat(1)
          this.mergeMapRM = InventoryHelper.mergeMapMultiple(inventoryArrayRM, this.savedInputsRM)
          this.debitMapRM = this.convertDBInputsToDebitMaps(this.savedInputsRM, this.mergeMapRM)

          var invMapPKG = inventory_response_pkg.data.map
          var inventoryArrayPKG= Object.values(invMapPKG).flat(1)
          this.mergeMapPKG = InventoryHelper.mergeMapMultiple(inventoryArrayPKG, this.savedInputsPKG)
          this.debitMapPKG = this.convertDBInputsToDebitMaps(this.savedInputsPKG, this.mergeMapPKG)

          this.lastSave.debitMapRM = JSON.parse(JSON.stringify(this.debitMapRM))
          this.lastSave.debitMapPKG = JSON.parse(JSON.stringify(this.debitMapPKG))
          
        }))
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
        })
        .then(() => {
          this.pageLoading = false
          this.allowAutomaticCalculations = true
        })
    }
  },
  created () {
    if (this.outputID !== 'new') {
      // edit mode
      this.apiChainLoader()
    } else {
      this.pageLoading = false
      this.allowAutomaticCalculations = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>